export default "__VITE_ASSET__E6d1$SWO__"